export const name = '@bigmi/react'
export const version = '0.9.0'
